import {
  ArtistCategories,
  ArtistDetails,
  ArtistManagement,
  ClaimAdmin,
  ListOrders,
  menuRoutes,
  SettingsPage,
  Signout,
} from 'features';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

export const Routes: React.FunctionComponent = () => (
  <Switch>
    <Route
      path={menuRoutes.ARTISTAS}
      exact={true}
      component={ArtistManagement}
    />
    <Route
      path={`${menuRoutes.ARTISTAS}/:id`}
      component={ArtistDetails}
    />
    <Route
      path={menuRoutes.CATEGORIES}
      component={ArtistCategories}
    />
    <Route
      path={menuRoutes.PEDIDOS}
      exact={true}
      component={ListOrders}
    />
    <Route
      path={menuRoutes.ADMIN}
      exact={true}
      component={ClaimAdmin}
    />
    <Route
      path={menuRoutes.SETTINGS}
      exact={true}
      component={SettingsPage}
    />
    <Route path={menuRoutes.SIGNOUT} component={Signout} />
  </Switch>
);
